import React, { Component } from "react";
import KickImage from 'Reuseables/KickImage';
import axios from "axios";
import { connect } from "react-redux";
import { Row, Col, Container, Button } from "reactstrap";
import { Spinner } from "react-bootstrap";
import classNames from "classnames";
import { Link } from "react-router-dom";
import orangIcon from "../../../images/orang.png";
import {
  getCollectionProductBrands,
  getCollectionBrands,
  getProductBrandByFilter,
  getImageBanner,
} from "../../../actions/kafairAction";
import SneakerImage from "../../../components/Sneakers/SneakerImage";
import { TextRupiah } from "../../../components/Text";
import { getCloudImageUrl } from "../../../utils";
import Thumbnails from "../../PageProductDetails/Detail/Thumbnails";
import Countdown, { zeroPad } from "react-countdown";
import moment from "moment";
import bgImage from "../../../images/event_background.jpeg";
import styled from "styled-components";
import RaffleNovembazar from "./RaffleNovembazar";
import LeftArrowSlick from "../../../images/left-slick-arrow.png";
import RightArrowSlick from "../../../images/right-slick-arrow.png";
import { API_BASE_URL } from "../../../constants";

import Slider from "react-slick";

import LeftArrowFilter from "../../../images/filter-mii-left.png";
import RightArrowFilter from "../../../images/filter-mii-right.png";

// IMPORT ARROW
import LifeStyle_Arrow_Next from "../../../images/arrow/lifestyle_n.png";
import LifeStyle_Arrow_Prev from "../../../images/arrow/lifestyle_p.png";
import Luxury_Arrow_Next from "../../../images/arrow/lux_n.png";
import Luxury_Arrow_Prev from "../../../images/arrow/lux_p.png";
import Sneakers_Arrow_Next from "../../../images/arrow/raffle_holiday___sneakers_n.png";
import Sneakers_Arrow_Prev from "../../../images/arrow/raffle_holiday___sneakers_p.png";
import StreetWear_Arrow_Next from "../../../images/arrow/streetwear_next.png";
import StreetWear_Arrow_Prev from "../../../images/arrow/streetwear_previous.png";
import NextArrowBlack from "../../../images/bca-raffle-arrow-right.png";
import PrevArrowBlack from "../../../images/bca-raffle-arrow-left.png";
import { destroyObjectProperties } from "highcharts";

function PreviousArrowFilter(props) {
  const { className, style, onClick, category } = props;
  const LeftArrrow = styled.div`
    &::before {
      content: "" !important;
    }
    img {
      margin-left: 30px;
      width: 5px !important;
      height: 5px !important;
      object-fit: contain;
      border-radius: 30px;
      margin-bottom: 19px;
    }

    @media (max-width: 480px) {
      img {
        width: 20px !important;
        height: 20px !important;
        position: absolute;
        left: -36px;
      }
    }
  `;
  const LeftSliderIcon = () => {
    switch (category) {
      case "sneakers":
        return Sneakers_Arrow_Prev;
      case "lifestyles":
        return LifeStyle_Arrow_Prev;
      case "handbags":
        return Luxury_Arrow_Prev;
      case "apparels":
        return StreetWear_Arrow_Prev;
      default:
        return Sneakers_Arrow_Prev;
    }
  };
  return (
    <LeftArrrow
      className={className}
      style={{ ...style, display: "block" }}
      onClick={onClick}
    >
      <KickImage src={LeftArrowFilter} alt="..." className="slider-arrow arrow-left" />
    </LeftArrrow>
  );
}


function NextArrowFilter(props) {
  const { className, style, onClick, category } = props;
  const RightArrow = styled.div`
    &::before {
      content: "" !important;
    }
    img {
      margin-left: -5px;
      width: 3px !important;
      margin-bottom: 15px;
      height: 3px !important;
      object-fit: contain;
      border-radius: 30px;
    }

    @media (max-width: 480px) {
      img {
        width: 20px !important;
        height: 20px !important;
        position: absolute;
        left: -5px;
      }
    }
  `;
  const RightSliderIcon = () => {
    switch (category) {
      case "sneakers":
        return Sneakers_Arrow_Next;
      case "lifestyles":
        return LifeStyle_Arrow_Next;
      case "handbags":
        return Luxury_Arrow_Next;
      case "apparels":
        return StreetWear_Arrow_Next;
      default:
        return Sneakers_Arrow_Next;
    }
  };
  return (
    <RightArrow
      className={className}
      style={{ ...style, display: "block" }}
      onClick={onClick}
    >
      <KickImage
        src={RightArrowFilter}
        alt="..."
        className="slider-arrow arrow-right"
      />
    </RightArrow>
  );
}

const filterSettings = {
  arrows: true,
  // autoplay:true,
  infinite: false,
  speed: 500,
  slidesToShow: 7,
  slidesToScroll: 7,
  lazyLoad: false,
  dots: false,
  swipe: false,
  prevArrow: <PreviousArrowFilter />,
  nextArrow: <NextArrowFilter />,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    }
  ],
};

const FilterButton = ({
  item,
  onPress,
  buttonClick,
  category,
  mouseHover,
  mouseInfo,
  mouseHoverLeave,
}) => {
  return (
    <Button
      style={
        category === "lifestyles" || category === "handbags"
          ? {
            backgroundColor: "transparent",
            opacity:
              (buttonClick === item.name && item.name !== "") ||
                (mouseInfo === item.name && item.name !== "")
                ? "1"
                : "0.6",
            width: "100%",
            borderBottom:
              (buttonClick === item.name && item.name !== "") ||
                (mouseInfo === item.name && item.name !== "")
                ? "2px solid black"
                : "1px solid black",
            cursor: item.name === "" ? "default" : "pointer",
          }
          : {
            backgroundColor: "transparent",
            opacity:
              (buttonClick === item.name && item.name !== "") ||
                mouseInfo === item.name
                ? "1"
                : "0.6",
            width: "100%",
            borderBottom:
              (buttonClick === item.name && item.name !== "") ||
                mouseInfo === item.name
                ? "2px solid white"
                : "1px solid white",
            cursor: item.name === "" ? "default" : "pointer",
          }
      }
      className="filter-price"
      onClick={item.name === "" ? null : () => onPress()}
      onMouseEnter={mouseHover}
      onMouseLeave={mouseHoverLeave}
    >
      <p
        style={
          category === "lifestyles" || category === "handbags"
            ? { color: "black", marginBottom: "20px", fontSize: "12px" }
            : { color: "#fff", marginBottom: "20px", fontSize: "12px" }
        }
      >
        {item.text.includes(">=") && <span>&ge;</span>}
        {item.text.includes(">=") ? item.text.replace(">=", "") : item.text}
      </p>
    </Button>
  );
};

function NextArrow(props) {
  const { className, style, onClick, category } = props;
  const RightArrow = styled.div`
    &::before {
      content: "" !important;
    }
  `;
  const RightSliderIcon = () => {
    switch (category) {
      case "sneakers":
        return Sneakers_Arrow_Next;
      case "lifestyles":
        return LifeStyle_Arrow_Next;
      case "handbags":
        return Luxury_Arrow_Next;
      case "apparels":
        return StreetWear_Arrow_Next;
      default:
        return Sneakers_Arrow_Next;
    }
  };
  return (
    <RightArrow
      className={className}
      style={{ ...style, display: "block" }}
      onClick={onClick}
    >
      <KickImage
        src={NextArrowBlack}
        alt="..."
        className="slider-arrow arrow-right"
      />
    </RightArrow>
  );
}

function PreviousArrow(props) {
  const { className, style, onClick, category } = props;
  const LeftArrrow = styled.div`
    &::before {
      content: "" !important;
    }
  `;
  const LeftSliderIcon = () => {
    switch (category) {
      case "sneakers":
        return Sneakers_Arrow_Prev;
      case "lifestyles":
        return LifeStyle_Arrow_Prev;
      case "handbags":
        return Luxury_Arrow_Prev;
      case "apparels":
        return StreetWear_Arrow_Prev;
      default:
        return Sneakers_Arrow_Prev;
    }
  };
  return (
    <LeftArrrow
      className={className}
      style={{ ...style, display: "block" }}
      onClick={onClick}
    >
      <KickImage src={PrevArrowBlack} alt="..." className="slider-arrow arrow-left" />
    </LeftArrrow>
  );
}

class CategorySection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      isFetching: false,
      availables: true,
      hasMoreData: false,
      currentIndex: 0,
      fetchBrandError: false,
      brandId: null,
      filterListSneakers: [
        {
          name: "low_price",
          text: "< 1 juta",
          activeColor: "rgb(101, 152, 160)",
          color: "rgba(101, 152, 160, 0.3)",
          start_price: 0,
          end_price: 999999,
          isActive: false,
        },
        {
          name: "middle_price",
          text: "1 juta-an",
          activeColor: "rgb(131, 38, 13)",
          color: "rgba(131, 38, 13, 0.3)",
          start_price: 1000000,
          end_price: 1999999,
          isActive: false,
        },
        {
          name: "high_price",
          text: "2 juta-an",
          activeColor: "rgb(246, 187, 104)",
          color: "rgba(246, 187, 104, 0.3)",
          start_price: 2000000,
          end_price: 2999999,
          isActive: false,
        },
        {
          name: "super_high_price",
          text: "3 juta-an",
          activeColor: "rgb(246, 187, 104)",
          color: "rgba(246, 187, 104, 0.3)",
          start_price: 3000000,
          end_price: 3999999,
          isActive: false,
        },
        {
          name: "extra_high_price",
          text: "4 juta-an",
          activeColor: "rgb(246, 187, 104)",
          color: "rgba(246, 187, 104, 0.3)",
          start_price: 4000000,
          end_price: 4999999,
          isActive: false,
        },
        {
          name: "extreme_high_price",
          text: ">= 5 juta",
          activeColor: "rgb(246, 187, 104)",
          color: "rgba(246, 187, 104, 0.3)",
          start_price: 5000000,
          end_price: 5000000000,
          isActive: false,
        },
      ],
      filterListLuxury: [
        {
          name: "",
          text: "",
          activeColor: "rgb(101, 152, 160)",
          color: "rgba(101, 152, 160, 0.3)",
          start_price: this.start_price,
          end_price: this.end_price,
          isActive: false,
        },
        {
          name: "low_price",
          text: "< 2 juta",
          activeColor: "rgb(101, 152, 160)",
          color: "rgba(101, 152, 160, 0.3)",
          start_price: 0,
          end_price: 1999999,
          isActive: false,
        },
        {
          name: "middle_price",
          text: "2-5 juta",
          activeColor: "rgb(131, 38, 13)",
          color: "rgba(131, 38, 13, 0.3)",
          start_price: 2000000,
          end_price: 4999999,
          isActive: false,
        },
        {
          name: "high_price",
          text: "5-10 juta",
          activeColor: "rgb(246, 187, 104)",
          color: "rgba(246, 187, 104, 0.3)",
          start_price: 5000000,
          end_price: 9999999,
          isActive: false,
        },
        {
          name: "super_high_price",
          text: ">10 juta",
          activeColor: "rgb(246, 187, 104)",
          color: "rgba(246, 187, 104, 0.3)",
          start_price: 10000000,
          end_price: 10000000000000,
          isActive: false,
        },
        {
          name: "",
          text: "",
          activeColor: "rgb(101, 152, 160)",
          color: "rgba(101, 152, 160, 0.3)",
          start_price: this.start_price,
          end_price: this.end_price,
          isActive: false,
        },
      ],
      filterListLifestyle: [
        {
          name: "",
          text: "",
          activeColor: "rgb(101, 152, 160)",
          color: "rgba(101, 152, 160, 0.3)",
          start_price: this.start_price,
          end_price: this.end_price,
          isActive: false,
        },
        {
          name: "funko-pop",
          text: "FUNKO POP",
          activeColor: "rgb(101, 152, 160)",
          color: "rgba(101, 152, 160, 0.3)",
          start_price: 0,
          end_price: 100000000000,
          isActive: false,
        },
        {
          name: "games-consoles",
          text: "GAMES & CONSOLES",
          activeColor: "rgb(131, 38, 13)",
          color: "rgba(131, 38, 13, 0.3)",
          start_price: 1000000,
          end_price: 100000000000,
          isActive: false,
        },
        {
          name: "supreme-lifestyles",
          text: "SUPREME",
          activeColor: "rgb(131, 38, 13)",
          color: "rgba(131, 38, 13, 0.3)",
          start_price: 1000000,
          end_price: 100000000000,
          isActive: false,
        },
        {
          name: "casio",
          text: "G-SHOCK",
          activeColor: "rgb(131, 38, 13)",
          color: "rgba(131, 38, 13, 0.3)",
          start_price: 0,
          end_price: 100000000000,
          isActive: false,
        },
        {
          name: "",
          text: "",
          activeColor: "rgb(101, 152, 160)",
          color: "rgba(101, 152, 160, 0.3)",
          start_price: this.start_price,
          end_price: this.end_price,
          isActive: false,
        },
      ],
      selectedPrice: null,
      start_price: 0,
      end_price: 0,
      filterButtonClick: "",
      buttonText: "",
      mouseEnter: false,
      localBrandsList: [],
      selectedCurrentBrand: "All",
      localBrands: {},
      raffleBanner: [],
      brandsList: [],
      productListMadeInIndonesia: [],
      name: "",
      description: "",
      isErrorCollection: false
    };
  }

  async componentDidMount() {
    this.props
      .getCollectionBrands(
        {
          page: 1,
          per_page: 30,
        },
        "local-brands"
      )
      .then(({ value }) => {
        const { name, description } = value.data || {};
        this.setState({
          name,
          description,
        });
      });

    if (this.props.category === "lifestyles") {
      const {
        data: {
          data: { brands },
        },
      } = await axios.get(
        `${API_BASE_URL}/collections/all/harbolkick-lifestyles-brand`
      );
      // console.log("RESPONSE: --->", response)

      const data = this.state.filterListLifestyle.map((item) => {
        const brand = brands.data.find((brand) => item.name === brand.slug);
        if (brand) {
          return {
            ...item,
            text: brand.title && brand.title !== "" ? brand.title : brand.name,
            id: brand.id,
          };
        }
        return item;
      });
      await this.setState({
        filterListLifestyle: [...data],
      });
    }
    try {
    } catch (error) {
      this.setState({ fetchBrandError: true });
    }
    this.getProductList();
    this.props
      .getImageBanner("local-brands", "local_brands", "kafair")
      .then(({ value }) => {
        const { categories = {} } = value.data || {};
        const { images = [] } = categories[0].pivot || {};
        this.setState({
          raffleBanner: images,
          isErrorCollection: false
        });
      })
      .catch((e) => {
        this.setState({ isErrorCollection: true })
      })
  }

  componentDidUpdate(prevProps) {
    // Deconstruct state
    const { selectedCurrentBrand } = this.state;

    // DECONSTRUCT PREV PROPS
    const { localBrands: prevLocalBrands = {} } = prevProps;
    const { brands: prevBrands = {}, products: prevProducts = {} } =
      prevLocalBrands || {};

    // DECONSTRUCT CURRENT PROPS
    const { localBrands = {} } = this.props;
    const { brands = {}, products = {} } = localBrands || {};

    if (prevBrands !== brands) {
      const { data = [] } = brands || {};
      this.setState({
        localBrands: localBrands,
        brandsList: data && [{ name: "All" }, ...data.sort((a, b) => {
          a.name.localeCompare(b.name)
        })],
      });
    }

    // HANDLE PENAMBAHAN CARD UNTUK SHOW BRAND PRODUCT LIST
    if (prevProducts !== products) {
      const { data = [] } = products || {};

      const newData = (() => {
        if (data.length === 0) return data;
        if (selectedCurrentBrand) {
          // MENAMBAHKAN JUMLAH PRODUCT UNTUK RENDER CARD SHOW ALL
          const { name: brandName = "" } =
            data.length > 0 ? data[0].product.brand : {};

          return [...data, { brandName }];
        }
        return data;
      })();
      this.setState({
        productListMadeInIndonesia: newData,
      });
    }
  }

  goToProductList = (data, filterPrice) => {
    if (filterPrice === "") {
      this.setState({
        filterButtonClick: "",
      });
    }

    const { title, name, category, icon, slug, background } = this.props;
    const params = {
      title,
      name,
      category,
      slug,
      background,
      icon,
      start_price: data === "" ? 0 : this.state.start_price,
      end_price: data === "" ? 0 : this.state.end_price,
      filterPrice: data === "" ? "" : this.state.filterButtonClick,
      brandId: this.state.brandId || null,
    };

    this.props.history.push(`/bcaxkickavenue/${slug}`, params);
  };

  gotToProductList2 = () => {
    const { slug } = this.props;
    const { selectedCurrentBrand } = this.state

    let paramsProductDetail = this.state.brandsList.find(item => item.name === this.state.selectedCurrentBrand)

    // const params = {
    //   selectedCurrentBrand: paramsProductDetail,
    // };
    if(paramsProductDetail.id) this.props.history.push(`/bcaxkickavenue/${slug}?brands=${paramsProductDetail.id}`)
      else this.props.history.push(`/bcaxkickavenue/${slug}`)
  };

  onApplyFilter = (priceAttr, data) => {
    this.setState(
      {
        selectedPrice: priceAttr,
        page: 1,
        start_price: priceAttr === "" ? 0 : data.start_price,
        end_price: priceAttr === "" ? 0 : data.end_price,
        filterButtonClick: priceAttr,
        buttonText: data.text,
        brandId: data.id || null,
      },
      () => {
        this.getProductList();
      }
    );
  };

  getProductList = () => {
    const { category, name, getCollectionProductBrands } = this.props;
    const { page, start_price, end_price, brandId, buttonText } = this.state;

    const payloadProducts = {
      page,
      per_page: 16,
      category,
      // start_price,
      // end_price,
    };
    if (category !== "lifestyles") {
      if (category === "local_brands") {
        const payloadProductsForMadeInIndonesia = {
          collection: "local-brands",
          collection_type: "brands",
          page: 1,
          per_page: 16,
          availables: true
        };

        getCollectionProductBrands(
          payloadProductsForMadeInIndonesia,
          "local_brands"
        );
        return;
      }
      payloadProducts.start_price = start_price;
      payloadProducts.end_price = end_price;
    } else if (category === "lifestyles") {
      if (brandId) payloadProducts.brands = brandId;
      else payloadProducts.keyword = buttonText;
    }

    getCollectionProductBrands(payloadProducts, name);
  };

  toggleMouseEnter = (data) => {
    this.setState({
      mouseEnter: data,
    });
  };

  _renderItems = (data) => {
    if (this.state.filterButtonClick !== "") {
      data.push({});
    }

    return data.map((item, index) => {
      const { slug } = this.props;
      const { selectedCurrentBrand } = this.state
      let paramsProductDetail = this.state.brandsList.find(item => item.name === this.state.selectedCurrentBrand)

      if (this.state.filterButtonClick !== "" && index === data.length - 1) {
        return (
          <div key={index} className="sneaker-item">
            <div
              className={classNames("product-card", {
                disabled: item.disabled,
              })}
              style={
                this.props.category === "sneakers"
                  ? { backgroundColor: "#0f3423" }
                  : this.props.category === "apparels"
                    ? { backgroundColor: "#7b1411" }
                    : this.props.category === "handbags"
                      ? { backgroundColor: "#ceceae" }
                      : this.props.category === "lifestyles"
                        ? { backgroundColor: "#e5c82d" }
                        : {}
              }
            >
              <a>
                <h4
                  style={{
                    textAlign: "center",
                    color: "white",
                    marginBottom: "0px",
                    fontSize: "28px",
                    fontFamily: "Nunito Regular"
                  }}
                >
                  Show All
                </h4>
                <h2
                  style={{
                    textAlign: "center",
                    color: "white",
                    fontWeight: "bold",
                    fontSize: "28px",
                    fontFamily: "Nunito Regular"
                  }}
                >
                  {this.props.title}
                </h2>
                <div
                  onClick={() => this.goToProductList()}
                  style={{
                    backgroundColor: "rgba(255, 255, 255, 0.2)",
                    width: "100%",
                    color: "white",
                    border: "none",
                    borderRadius: "5px",
                    fontWeight: "bold",
                    marginTop: "20px",
                    height: "30px",
                    textAlign: "center",
                    cursor: "pointer",
                  }}
                >
                  <p style={{ paddingTop: "7.5px", fontFamily: "Nunito Regular" }}>{this.state.buttonText}</p>
                </div>
              </a>
            </div>
          </div>
        );
      } else {
        return this.state.selectedCurrentBrand && index === data.length - 1 ? (
          <Link
            key={index}
            className="sneaker-item"
            // onClick={() => this.gotToProductList2()}
            to={{
              pathname: `/bcaxkickavenue/${slug}?brand=${paramsProductDetail.id}`
            }}
            target="_blank"
          >
            <div
              className="product-card show-all-selected-brand-wrapper"
            >
              <p>Show All</p>
              <p>{this.state.selectedCurrentBrand === "All" || !this.state.selectedCurrentBrand ? "Made in Indonesia" : this.state.selectedCurrentBrand}</p>
            </div>
          </Link>
        ) : (
          <div key={index} className="sneaker-item">
            <div
              className={classNames("product-card", {
                disabled: item.disabled,
              })}
              style={
                !item.price || item.out_of_stock
                  ? {
                    pointerEvents: "none",
                  }
                  : {}
              }
            >
              <a href={`/${item.category}/${item.id}/${item.slug}`}>
                <div
                  className={classNames("sneaker-item__text", {
                    disabled: !item.price || item.out_of_stock,
                  })}
                >
                  <p>{item.brandName}</p>
                  <p>{item.displayName}</p>
                </div>
                <KickImage
                  hasImage={item.hasImage}
                  src={item.src}
                  alt={item.displayName}
                  className={classNames("sneaker-item__image", {
                    disabled: !item.price || item.out_of_stock,
                  })}
                />
                {item.price ? (
                  <div style={{ textAlign: "center" }}>
                    <TextRupiah
                      value={item.price}
                      className="price-tag"
                      color="black"
                      bold={true}
                      align="center"
                      isFormatRupiah
                    />
                  </div>
                ) : (
                  <div style={{ textAlign: "center" }}>
                    <span className="text-center">X</span>
                  </div>
                )}
              </a>
            </div>
          </div>
        );
      }
    });
  };

  renderProducts = () => {
    const { category } = this.props;
    const {
      localBrands,
      selectedCurrentBrand,
      productListMadeInIndonesia,
      currentIndex,
      filterButtonClick,
    } = this.state;

    if (category === "local_brands") {
      const previewSettings = {
        arrows: true,
        infinite: false,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll:
          productListMadeInIndonesia.length >= 4
            ? 4
            : productListMadeInIndonesia.length + 1,
        lazyLoad: true,
        dots: false,
        swipe: true,
        responsive: [
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll:
                productListMadeInIndonesia.length >= 1
                  ? 1
                  : productListMadeInIndonesia.length + 1,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 3,
              slidesToScroll:
                productListMadeInIndonesia.length >= 3
                  ? 3
                  : productListMadeInIndonesia.length + 1,
            },
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll:
                productListMadeInIndonesia.length >= 3
                  ? 3
                  : productListMadeInIndonesia.length + 1,
            },
          },
        ],
        nextArrow: <NextArrow category={this.props.category} />,
        prevArrow: <PreviousArrow category={this.props.category} />,
      };

      return (
        <div>
          {productListMadeInIndonesia.length > 0 && !error > 0 ? (
            <Thumbnails
              settings={previewSettings}
              beforeChange={this._handleBeforeChange}
              thumbnails={productListMadeInIndonesia.map((item) => {
                const {
                  price = "",
                  out_of_stock = 0,
                  display_name = "",
                  product_variant_images = [],
                  slug = "",
                  id,
                  product = {},
                } = item || {};

                const {
                  brand: { title = "", name = "", flat = [] } = {},
                  category: { name: categoryName = "" } = {},
                } = product || {};

                return {
                  isMadeInIndonesiaSection: selectedCurrentBrand ? true : false,
                  disabled: !price || out_of_stock,
                  brandName: flat.length > 0 ? flat[0] : "",
                  displayName: display_name,
                  hasImage: product_variant_images.length > 0 ? true : false,
                  src: product_variant_images.length
                    ? getCloudImageUrl(product_variant_images[0].URL, 400)
                    : null,
                  price: price,
                  category: categoryName,
                  id: id,
                  slug: slug,
                };
              })}
              active={currentIndex}
              renderItems={(productList) => this._renderItems(productList)}
              filterButtonClick={filterButtonClick}
            />
          ) : (
            <p
              style={{
                fontSize: "14px",
                color:
                  this.props.category === "handbags" ||
                    this.props.category === "lifestyles"
                    ? "black"
                    : "white",
                fontWeight: "bold",
                marginTop: "100px",
                textAlign: "center",
                height: "100px",
                fontFamily: "Nunito Regular"
              }}
            >
              No products available
            </p>
          )}
        </div>
      );
    }

    const { productList = [], error } = this.props.dataCategory || {};
    const previewSettings = {
      arrows: true,
      infinite: false,
      speed: 500,
      slidesToShow: 4,
      slidesToScroll: productList.length >= 4 ? 4 : productList.length + 1,
      lazyLoad: true,
      dots: false,
      swipe: false,
      responsive: [
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll:
              productList.length >= 1 ? 1 : productList.length + 1,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
            slidesToScroll:
              productList.length >= 3 ? 3 : productList.length + 1,
          },
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll:
              productList.length >= 3 ? 3 : productList.length + 1,
          },
        },
      ],
      nextArrow: <NextArrow category={this.props.category} />,
      prevArrow: <PreviousArrow category={this.props.category} />,
    };

    return (
      <div>
        {productList && productList.length > 0 && !error > 0 ? (
          <Thumbnails
            settings={previewSettings}
            beforeChange={this._handleBeforeChange}
            thumbnails={productList.map((item) => {
              return {
                disabled: !item.price || item.out_of_stock,
                brandName:
                  item.product.brand && item.product.brand.title
                    ? item.product.brand && item.product.brand.title
                    : item.product.brand && item.product.brand.name,
                displayName: item.display_name,
                hasImage: item.product_variant_images.length > 0 ? true : false,
                src: item.product_variant_images.length
                  ? getCloudImageUrl(item.product_variant_images[0].URL, 400)
                  : null,
                price: item.price,
                category: item.product.category.name,
                id: item.id,
                slug: item.slug,
              };
            })}
            active={this.state.currentIndex}
            renderItems={(productList) => this._renderItems(productList)}
            filterButtonClick={this.state.filterButtonClick}
          />
        ) : (
          <p
            style={{
              fontSize: "14px",
              color:
                this.props.category === "handbags" ||
                  this.props.category === "lifestyles"
                  ? "black"
                  : "white",
              fontWeight: "bold",
              marginTop: "100px",
              textAlign: "center",
              height: "100px",
              fontFamily: "Nunito Regular"
            }}
          >
            No products available
          </p>
        )}
      </div>
    );
  };

  render() {
    const {
      filterListSneakers,
      filterListLifestyle,
      filterListLuxury,
      settings,
      selectedCurrentBrand,
      raffleBanner,
      brandsList,
      description,
      name: headerNameTitle,
    } = this.state;

    const {
      title,
      name,
      category,
      icon,
      slug,
      background,
      localBrands,
      header,
      getProductBrandByFilter,
    } = this.props;

    let style = {
      background: background,
      borderRadius: "10px",
      marginBottom: "50px",
    };

    const { products = {} } = localBrands || {};

    const bannerImage =
      raffleBanner.length > 0 &&
      raffleBanner.filter((img) =>
        window.screen.availWidth > 480
          ? img.orientation === "landscape"
          : img.orientation === "portrait"
      );

    const headerName = (() => {
      if (!headerNameTitle) return

      const splitedText = headerNameTitle.split("(")[0].split(" ");
      splitedText.splice(2, 1, `<span>Indonesia</span>`)
      return splitedText.join(" ").toUpperCase()
    })();

    if (this.state.isErrorCollection) return null;

    return (
      <Container fluid className="special-deals-section official novembazar">
        {bannerImage.length > 0 && (
          <KickImage
            className="background-image"
            src={bannerImage[0].URL}
            alt="made-in-indonesia"
          />
        )}
        <Row className="content-container made-in-indonesia">
          <Col md={12} xs={12}>
            {/* <div className="header-wrapper filter">
              {category === "handbags"
                ? filterListLuxury.map((item, index) => {
                    if (window.screen.availWidth < 740 && index === 0) {
                      return null;
                    } else if (
                      window.screen.availWidth < 740 &&
                      index === filterListLifestyle.length - 1
                    ) {
                      return null;
                    } else {
                      return (
                        <FilterButton
                          key={item.name}
                          item={item}
                          onPress={
                            item.name === ""
                              ? null
                              : () => this.onApplyFilter(item.name, item)
                          }
                          buttonClick={this.state.filterButtonClick}
                          category={category}
                          mouseInfo={this.state.mouseEnter}
                          mouseHover={() => this.toggleMouseEnter(item.name)}
                          mouseHoverLeave={() => this.toggleMouseEnter(false)}
                        />
                      );
                    }
                  })
                : category === "lifestyles"
                ? filterListLifestyle.map((item, index) => {
                    if (window.screen.availWidth < 740 && index === 0) {
                      return null;
                    } else if (
                      window.screen.availWidth < 740 &&
                      index === filterListLifestyle.length - 1
                    ) {
                      return null;
                    } else {
                      return (
                        <FilterButton
                          key={item.name}
                          item={item}
                          onPress={
                            item.name === ""
                              ? null
                              : () => this.onApplyFilter(item.name, item)
                          }
                          buttonClick={this.state.filterButtonClick}
                          category={category}
                          mouseHover={() => this.toggleMouseEnter(item.name)}
                          mouseInfo={this.state.mouseEnter}
                          mouseHoverLeave={() => this.toggleMouseEnter(false)}
                        />
                      );
                    }
                  })
                : filterListSneakers.map((item) => {
                    return (
                      <FilterButton
                        key={item.name}
                        item={item}
                        onPress={() => this.onApplyFilter(item.name, item)}
                        buttonClick={this.state.filterButtonClick}
                        mouseHover={() => this.toggleMouseEnter(item.name)}
                        mouseInfo={this.state.mouseEnter}
                        mouseHoverLeave={() => this.toggleMouseEnter(false)}
                      />
                    );
                  })}
            </div>
           */}
            <div className="title-wrapper">
              <p dangerouslySetInnerHTML={{ __html: `${headerName}` }} />
              <div className="description-wrapper">
                {description &&
                  description
                    .split("\n")
                    .map((str) => (
                      <p dangerouslySetInnerHTML={{ __html: `${str}` }} />
                    ))}
              </div>
            </div>
            {
              window.screen.availWidth > 480 ?
                <div className="filter-wrapper-scroll">
                  <div className="filter-wrapper">
                    <Slider {...filterSettings}>
                      {brandsList.length > 0 &&
                        brandsList.map((brand, index) => {
                          let isActive = (() => {
                            if (
                              selectedCurrentBrand &&
                              selectedCurrentBrand === brand.name
                            )
                              return "active";
                            if (!selectedCurrentBrand && index === 0) return "active";
                            return "";
                          })();

                          return (
                            <div
                              key={brand.id || index}
                              onClick={() => {
                                if (brand.name) {
                                  getProductBrandByFilter({
                                    brands: brand.id,
                                    availables: true
                                  });
                                  this.setState({
                                    selectedCurrentBrand: brand.name,
                                  });
                                } else {
                                  this.getProductList();
                                  this.setState({
                                    selectedCurrentBrand: null,
                                  });
                                }
                              }}
                              className="local-brands-wrapper"
                              style={{ textAlign: "center" }}
                            >
                              <p style={{ textAlign: "center", fontFamily: selectedCurrentBrand === brand.name && "Nunito Bold" }} className={`${isActive}`}>{brand.name}</p>
                            </div>
                          );
                        })}
                    </Slider>
                  </div>
                </div>
                :
                <div style={{ overflowY: "hidden", overflowX: "visible" }} className="filter-wrapper-scroll">
                  <div className="filter-wrapper">
                    {brandsList.length > 0 &&
                      brandsList.map((brand, index) => {
                        let isActive = (() => {
                          if (
                            selectedCurrentBrand &&
                            selectedCurrentBrand === brand.name
                          )
                            return "active";
                          if (!selectedCurrentBrand && index === 0) return "active";
                          return "";
                        })();

                        return (
                          <div
                            key={brand.id || index}
                            onClick={() => {
                              if (brand.name) {
                                getProductBrandByFilter({
                                  brands: brand.id,
                                  availables: true
                                });
                                this.setState({
                                  selectedCurrentBrand: brand.name,
                                });
                              } else {
                                this.getProductList();
                                this.setState({
                                  selectedCurrentBrand: null,
                                });
                              }
                            }}
                            className="local-brands-wrapper"
                            style={{ textAlign: "center", marginLeft: index > 0 && "20px" }}
                          >
                            <p style={{ textAlign: "center", fontFamily: selectedCurrentBrand === brand.name && "Nunito Bold" }}>{brand.name}</p>
                          </div>
                        );
                      })}
                  </div>
                </div>
            }
          </Col>
          <Col md={12} xs={12}>
            <div
              id="product-card-wrapper"
              className="right-side local-brands official category"
            >
              {products.isFetching ? (
                <div className="local-brands-loading-wrapper">
                  <div>
                    <Spinner animation="border" role="status" />
                  </div>
                  <p>Loading...</p>
                </div>
              ) : (
                this.renderProducts()
              )}
            </div>
          </Col>
          <div className="view-all-button">
            <Link
              // to={`/bcaxkickavenue/${slug}`} 
              to={{
                pathname: `/bcaxkickavenue/${slug}`,
                state: { selectedCurrentBrand: null }
              }}
              target="_blank">
              <p>View All</p>
            </Link>
          </div>
        </Row>
      </Container >
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { name } = ownProps;

  return {
    dataCategory: state.dataKaFair[name],
    localBrands: state.dataKaFair.local_brands,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getCollectionProductBrands: (payload, name) =>
    dispatch(getCollectionProductBrands(payload, name)),
  getCollectionBrands: (payload, slug) =>
    dispatch(getCollectionBrands(payload, slug)),
  getProductBrandByFilter: (payload) =>
    dispatch(getProductBrandByFilter(payload)),
  getImageBanner: (slug, name, category) =>
    dispatch(getImageBanner(slug, name, category)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CategorySection);
